import { Breadcrumb } from 'rsuite';
import { menuHierarchy } from './sidenavbar-menuHierarchy';


export function buildBreadcrumbs(activeKey: string): string[] {
    const crumbs: string[] = [];
    let currentKey = activeKey;
  
    while (currentKey) {
      const item = menuHierarchy[currentKey];
      if (!item) break;
      crumbs.unshift(item.label);
      currentKey = item.parent || '';
    }
  
    return crumbs;
  }